import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=18903f64&scoped=true&"
import script from "./Restore.vue?vue&type=script&lang=js&"
export * from "./Restore.vue?vue&type=script&lang=js&"
import style0 from "./Restore.vue?vue&type=style&index=0&id=18903f64&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18903f64",
  null
  
)

export default component.exports